export default __webpack_public_path__ + "static/media/Inconsolata-Regular.55d67e89.woff2";